import React from 'react';
import { MapPin, Package, User, CheckCircle, Edit3, Clock } from 'lucide-react';

const AssetCard = ({ asset, buildings, setSelectedAsset, openEditModal, openHistoryModal, hasPermission }) => (
  <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 hover:shadow-md transition-shadow">
    <div className="flex justify-between items-start mb-3">
      <h3 className="font-semibold text-gray-900 text-lg cursor-pointer"
        onClick={() => setSelectedAsset(asset)}>
        {asset.name}
      </h3>
      <div className="flex items-center gap-2">
        <span className={`px-2 py-1 rounded-full text-xs font-medium ${asset.status === "active"
          ? "bg-green-100 text-green-800"
          : "bg-red-100 text-red-800"
          }`}>
          {asset.status}
        </span>
      </div>
    </div>

    {asset.asset_tag && (
      <div className="mb-2">
        <span className="inline-block bg-gray-100 text-gray-800 px-2 py-1 rounded text-xs font-mono">
          {asset.asset_tag}
        </span>
      </div>
    )}

    {asset.description && (
      <p className="text-gray-600 text-sm mb-2 line-clamp-2">{asset.description}</p>
    )}

    <div className="space-y-1 text-sm text-gray-500 mb-4">
      {asset.location && (
        <div className="flex items-center gap-1">
          <MapPin size={14} /><span>{asset.location}</span>
        </div>
      )}
      {asset.category && (
        <div className="flex items-center gap-1">
          <Package size={14} /><span>{asset.category}</span>
        </div>
      )}
      {asset.assigned_to && (
        <div className="flex items-center gap-1">
          <User size={14} /><span>{asset.assigned_to}</span>
        </div>
      )}
      {asset.building_id && (() => {
        const building = buildings.find(b => String(b.id) === String(asset.building_id));
        return building ? (
          <div className="flex items-center gap-1 text-blue-600">
            <CheckCircle size={14} />
            <span className="truncate">{building.buildingName}</span>
          </div>
        ) : null;
      })()}
    </div>

    {hasPermission("edit_asset_details") && (
      <div className="flex gap-2 flex-wrap">
        <button
          onClick={() => openEditModal(asset)}
          className="flex items-center gap-1 px-3 py-1.5 text-sm bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 transition-colors"
        >
          <Edit3 size={14} /> Edit
        </button>
        <button
          onClick={() => openHistoryModal(asset)}
          className="flex items-center gap-1 px-3 py-1.5 text-sm bg-gray-50 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
        >
          <Clock size={14} /> History
        </button>
      </div>
    )}
  </div>
);

export default AssetCard;
